import type { NavigationLevel } from '../../context/navigationContextCore'

type ResourceReadinessVisibilityOptions = {
  currentLevel: NavigationLevel
}

export const shouldShowResourceReadinessPanel = ({
  currentLevel,
}: ResourceReadinessVisibilityOptions): boolean =>
  currentLevel === 'dashboard'
